"use strict";
import { createSlice } from "@reduxjs/toolkit";
import { getValidAddress } from "utils/addresses";
import { buildCurrencyId } from "utils/uniswapCurrencyId";
import { logger } from "utilities/src/logger/logger";
const OVERRIDE_MAX_AGE = 30 * 60 * 1e3;
export const initialPortfolioState = {
  tokenBalanceOverrides: {}
};
const slice = createSlice({
  name: "portfolio",
  initialState: initialPortfolioState,
  reducers: {
    addTokensToBalanceOverride: (state, action) => {
      const { ownerAddress, currencyIds } = action.payload;
      const accountId = getValidAddress(ownerAddress);
      if (!accountId) {
        logger.error(new Error("Unexpected call to `addTokensToBalanceOverride` with an invalid address"), {
          tags: { file: "portfolio/slice/slice.ts", function: "addTokensToBalanceOverride" },
          extra: { ownerAddress, currencyIds }
        });
        return;
      }
      const accountOverrides = state.tokenBalanceOverrides[accountId] ?? {};
      const now = (/* @__PURE__ */ new Date()).getTime();
      currencyIds.forEach((currencyId) => {
        accountOverrides[currencyId] = {
          updatedAt: now
        };
      });
      state.tokenBalanceOverrides[accountId] = accountOverrides;
    },
    removeTokenFromBalanceOverride: (state, action) => {
      const { ownerAddress, chainId, tokenAddress } = action.payload;
      const accountId = getValidAddress(ownerAddress);
      if (!accountId) {
        logger.error(new Error("Unexpected call to `removeTokenFromBalanceOverride` with an invalid address"), {
          tags: { file: "portfolio/slice/slice.ts", function: "removeTokenFromBalanceOverride" },
          extra: { ownerAddress, chainId, tokenAddress }
        });
        return;
      }
      const currencyId = buildCurrencyId(chainId, tokenAddress).toLowerCase();
      delete state.tokenBalanceOverrides[accountId]?.[currencyId];
      if (Object.keys(state.tokenBalanceOverrides[accountId] ?? {}).length === 0) {
        delete state.tokenBalanceOverrides[accountId];
      }
    },
    removeExpiredBalanceOverrides: (state) => {
      Object.keys(state.tokenBalanceOverrides).forEach((accountId) => {
        const accountOverrides = state.tokenBalanceOverrides[accountId];
        const now = Date.now();
        Object.keys(accountOverrides).forEach((currencyId) => {
          if (now - accountOverrides[currencyId].updatedAt > OVERRIDE_MAX_AGE) {
            logger.warn(
              "portfolio/slice/slice.ts",
              "removeExpiredBalanceOverrides",
              `[ITBU] Removing expired token balance override for ${accountId}: ${currencyId}`
            );
            delete accountOverrides[currencyId];
          }
        });
        if (Object.keys(accountOverrides).length === 0) {
          delete state.tokenBalanceOverrides[accountId];
        }
      });
    }
  }
});
export const { addTokensToBalanceOverride, removeTokenFromBalanceOverride, removeExpiredBalanceOverrides } = slice.actions;
export const portfolioReducer = slice.reducer;
